import { render, staticRenderFns } from "./DoctorIdleEnter.vue?vue&type=template&id=dd97b31a&scoped=true"
import script from "./DoctorIdleEnter.vue?vue&type=script&lang=js"
export * from "./DoctorIdleEnter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd97b31a",
  null
  
)

export default component.exports